var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRsvpButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1562,
    y: 0.5,
    width: 9.75,
    height: 9,
    rx: 1.125,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5938 5C10.5938 4.65482 10.6264 4.375 10.6666 4.375H16.7709C16.8111 4.375 16.8438 4.65482 16.8438 5C16.8438 5.34518 16.8111 5.625 16.7709 5.625H10.6666C10.6264 5.625 10.5938 5.34518 10.5938 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3524 1.68835C14.5202 1.52055 14.7923 1.52055 14.9601 1.68835L17.9679 4.69617C18.1357 4.86397 18.1357 5.13603 17.9679 5.30383L14.9601 8.31165C14.7923 8.47945 14.5202 8.47945 14.3524 8.31165C14.1846 8.14384 14.1846 7.87178 14.3524 7.70398L17.0564 5L14.3524 2.29602C14.1846 2.12822 14.1846 1.85616 14.3524 1.68835Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.09375 5C0.09375 4.58579 0.152441 4.25 0.224841 4.25H11.2127C11.2851 4.25 11.3438 4.58579 11.3438 5C11.3438 5.41421 11.2851 5.75 11.2127 5.75H0.224841C0.152441 5.75 0.09375 5.41421 0.09375 5Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRsvpButtonIcon);
export default __webpack_public_path__ + "static/media/dashboard-rsvp-button-icon.422f4ceead8ab873e3defea735a4bf6e.svg";
export { ForwardRef as ReactComponent };